module.exports = __webpack_public_path__ + "img/2.d51184f9.png";